<div class="modal-header">
    <h2 class="modal-title" translate>lblAddService</h2>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body">
    <div class="popup-vcenter flmidall w-100">
        <div class="middle-container-data w-100 p-0">
            <div class="row mb-3">
                <div class="col-4">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="search" [(ngModel)]="serviceSearchTerm"
                            (keyup.enter)="GetSearchedServices()">
                        <div class="input-group-append">
                            <button type="button" aria-label="Center Align" class="btn btn-primary"
                                (click)="GetSearchedServices()">
                                <em aria-hidden="true" class="fa fa-search"></em>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    
                </div>
            </div>
            <div class="services-data w-100">
                <ul role="tablist" class="justify-content-start nav nav-tabs bg-grey">
                    <li *ngFor="let button of serviceCategories; let i = index"
                        (click)="onServiceCategorySelection(button.service,button.id)" class="nav-item ">
                        <a role="tab" [ngClass]="(button.clicked == true && isViewSearch == false) ? 'nav-link active' : 'nav-link'">
                            {{button.service}}
                        </a>
                    </li>
                    <li class="nav-item ">
                        <a role="tab" [ngClass]="isViewSearch == true ? 'nav-link active' : 'nav-link'"
                            (click)="onServiceSearch()">
                            Search result
                        </a>
                    </li>
                </ul>
                <div class="p-3 border service-scroll">
                    <ul class="form-row" *ngIf="isViewSearch == false">
                        <ng-container *ngFor="let service of services; let i = index">
                            <li class="serviceblock col-sm-12 col-md-6 col-lg-6">
                                <div type="checkbox" class="card p-2 mb-2 flex-column" (click)="onServiceSelected(service,service.isServiceChecked,$event)"
                                    [ngClass]="{selected: service.isServiceChecked}">
                                    <div class="d-flex w-100">
                                        <div class="service-img text-center mr-3">
                                            <img af-image [data-code]="service.logo" [src]="service.logo" style="width: 70px" height="50px" alt="" />
                                        </div>
                                        <div class="d-flex flex-column w-100">
                                            <div class="form-check pl-0">

                                                <label for="Service{{service.id}}" ngbTooltip="{{service.internalDescription}}" container="body" class=" ">
                                                    <input type="checkbox" class="align-middle mr-2" id="Service{{service.id}}" [(ngModel)]="service.isServiceChecked"
                                                        />
                                                    <span class="font18 text-dark">{{service.serviceNo}} - {{service.name}}
                                                    </span>
                                                </label>
                                            </div> 
                                            <div class="discription pl26">
                                                <p class="font16">{{service.description}} - {{service.price}}</p>
                                                <p class="font16" *ngIf="service.aFxPackageNo != ''">{{service.aFxPackageNo}} - {{service.afxPackageVersionNo}}</p>
                                                <div class="af-form-group mt-3" style="display:none ;">
                                                    <label for="">Text label</label>
                                                    <textarea name="" id="" rows="2"
                                                        class="form-control"></textarea>
                                                </div>
                                            </div>
                                            <div *ngIf="isWarningLightFeature">
                                                <div class="warningLights discription border rounded-3 p-3 mt-2" *ngIf="service.isWarningLight" (click)="stopEvent($event)">
                                                    <label translate>lblWarningLight<span>:</span></label>
                                                    <div>
                                                        <span class=" d-inline-block position-relative mr-3 bodyIcons"
                                                            *ngFor="let warninglight of service.warningLightService"
                                                            [ngClass]="{'selectedWarningLights':warninglight.isSelected }">
                                                            <img af-image [data-code]="warninglight.image" [attr.alt]="warninglight.WarningNameName"
                                                                [ngClass]="{'disable' : !service.isServiceChecked}"
                                                                (click)="warninglight.isSelected=!warninglight.isSelected" width="70px">
                                                            <em class="fas fa-check-circle"></em>
                                                        </span>
                                                    </div>
                                            
                                                </div>
                                            </div>


                                            <div *ngIf="service.isServiceChecked">
                                                
                                              <div class="d-flex w-100 " *ngFor="let childservice of service.displaychildServiceDetail; let i = index">
                                                <div class="w-100 border  mt-3 p-2 px-3"  (click)="stopEventOfChildService($event,childservice)">
                                                    <div class="form-check pl-0">
    
                                                        <label for="childservice{{childservice.id}}" ngbTooltip="{{childservice.name}}" container="body" class=" ">
                                                        <input type="checkbox" class="align-middle mr-2" id="childservice{{childservice.id}}" [disabled]="false"
                                                        [(ngModel)]="childservice.isServiceChecked" />
                                                        <span class="font18">{{childservice.serviceNo}} - {{childservice.name}}</span></label>
                                                    </div>
                                                    <div class="discription  pl26">
                                                        <p class="font16">{{childservice.description}}</p>
                                                        <p class="font16" *ngIf="childservice.aFxPackageNo != ''">{{childservice.aFxPackageNo}} - {{childservice.afxPackageVersionNo}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        
                                    </div>


                                </div>
                            </li>
                        </ng-container>
                    </ul>
                    <ul class="form-row" *ngIf="isViewSearch == true">
                        <ng-container *ngFor="let service of SearchedServices; let i = index">
                            <li class="serviceblock col-sm-12 col-md-6 col-lg-6">
                                <div class="card p-2 mb-2 flex-column" (click)="onServiceSelected(service,service.isServiceChecked,$event)"
                                    [ngClass]="{selected: service.isServiceChecked}">
                                    <div class="d-flex w-100">
                                        <div class="service-img text-center mr-3">
                                            <img af-image [data-code]="service.logo" style="width: 70px" height="50px" alt="" />
                                        </div>
                                        <div class="d-flex flex-column w-100">
                                            <div class="form-check pl-0">
                                                <label for="Service{{service.id}}" ngbTooltip="{{service.name}}"
                                                    class=" ">
                                                    <input type="checkbox" class="align-middle mr-2"
                                                        id="Service{{service.id}}" [disabled]="service.isDisable"
                                                        [(ngModel)]="service.isServiceChecked"
                                                         />
                                                    <span class="font18 text-dark">{{service.serviceNo}} - {{service.name}}</span>
                                                </label>
                                            </div>
                                            <div class="discription pl26">
                                                <p class="font16">{{service.description}}</p>
                                                <p class="font16" *ngIf="service.aFxPackageNo != ''">{{service.aFxPackageNo}} - {{service.afxPackageVersionNo}}</p>
                                                <div class="af-form-group mt-3" style="display:none ;">
                                                    <label for="">Text label</label>
                                                    <textarea name="" id="" rows="2"
                                                        class="form-control"></textarea>
                                                </div>

                                            </div>
                                            <div *ngIf="service.isServiceChecked">
                                                <div class="d-flex w-100 "  *ngFor="let childservice of service.displaychildServiceDetail; let i = index">
                                                    <div class="w-100 border  mt-3 p-2 px-3"
                                                    (click)="stopEventOfChildService($event,childservice)" >
                                                        <div class="form-check pl-0" >

                                                            <label for="childservice{{childservice.id}}"
                                                                ngbTooltip="{{childservice.name}}" class=" ">
                                                                <input type="checkbox" class="align-middle mr-2"
                                                                    id="childservice{{childservice.id}}"
                                                                    [disabled]="false"
                                                                    [(ngModel)]="childservice.isServiceChecked" />
                                                                <span
                                                                    class="font18">{{childservice.serviceNo}} -{{childservice.name}}</span></label>
                                                        </div>
                                                        <div class="discription  pl26">
                                                            <p class="font16">{{childservice.description}}</p>
                                                            <p class="font16" *ngIf="childservice.aFxPackageNo != ''">{{childservice.aFxPackageNo}} - {{childservice.afxPackageVersionNo}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                                                    
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary btn-lg"  (click)="onSaveService()"
        aria-label="Center Align" translate>lblAdd</button>
    <button type="button" class="btn btn-secondary btn-lg"
    (click)="OnClose()" aria-label="Center Align" translate>lblClose</button>
</div>